<template>
  <div class="dhr-list">
    <div class="detail-table-x2">
      <div class="qr-button" @click.stop="openQR(details.stepDetails.stepID)" >
        <BaseIcon name="qrcode" class="icon" size="sm" />
      </div>
      <div v-if="isQROpen && openedQR == details.stepDetails.stepID" class="fullscreen">

        <div class="imageview sm" v-if="details.stepDetails.QRParameter === null">
          <button class="btn-close" @click.stop="closeQR">
            <BaseIcon name="window-close" class="icon" />
          </button>
          <qr-code :text="qrString[0]" :size="200" error-level="L"/>
        </div>
        
        <div class="imageview m" v-if="details.stepDetails.QRParameter !== null">
          <button class="btn-close" @click.stop="closeQR">
            <BaseIcon name="window-close" class="icon" />
          </button>
          <div class="qr-container">
            <div class="qr-codes" v-for="(string, index) in qrString" :key="index">
              <div class="qr-code">
                <qr-code :text="string" :size="200" error-level="L"/>
                <span v-if="details.stepDetails.QRParameter !== null && details.stepDetails.QRParameters[index]">{{ details.stepDetails.QRParameter }}: {{ details.stepDetails.QRParameters[index].name }}</span>
              </div>
            </div>
          </div>
        </div>

      </div>
      <table class="detail-table">
        <h4 class="content-subtitle">Default values</h4>
        <div class="detail-table-head">
          <span class="large">Description</span>
          <span class="big">Input</span>
        </div>
        <div class="detail-table-body">
          <div class="body-row">
            <span class="large">Equipment</span>
            <span v-if="details.stepDetails" class="big">{{ details.stepDetails.equipment }}</span>
            <span v-else class="big">/</span>
          </div>
          <div class="body-row">
            <span class="large">Work Instruction</span>
            <span v-if="details.stepDetails" class="big">{{ details.stepDetails.instruction }}</span>
            <span v-else class="big">/</span>
          </div>
          <div class="body-row">
            <span class="large">REF</span>
            <span v-if="details.stepDetails" class="big">{{ details.stepDetails.stepID }}</span>
            <span v-else class="big">/</span>
          </div>
          <div class="body-row">
            <span class="large">Location</span>
            <span v-if="details.stepDetails" class="big">{{ details.stepDetails.location }}</span>
            <span v-else class="big">/</span>
          </div>
          <div class="body-row">
            <span class="large">Operator</span>
            <span v-if="details.stepCompletion" class="big">{{ details.stepCompletion.firstname + ' ' + details.stepCompletion.lastname }}</span>
            <span v-else class="big no-completion"> - step not completed -</span>
          </div>
          <div class="body-row">
            <span class="large">Date</span>
            <span v-if="details.stepCompletion" class="big">{{ details.stepCompletion.date | formatDateTime }}</span>
            <span v-else class="big no-completion"> - step not completed -</span>
          </div>
          <div class="body-row">
            <span class="large">Deviation N°</span>
            <span v-if="details.stepDeviations" class="big">{{ details.stepDeviations.deviationID }}</span>
            <span v-else-if="details.stepCompletion" class="big">No deviations</span>
            <span v-else class="big no-completion"> - step not completed -</span>
          </div>
          <div class="body-row">
            <span class="large">Deviation Comment</span>
            <span v-if="details.stepDeviations" class="big">{{ details.stepDeviations.comment }}</span>
            <span v-else-if="details.stepCompletion" class="big">No deviations</span>
            <span v-else class="big no-completion"> - step not completed -</span>
          </div>
        </div>
      </table>
      <table class="detail-table">
        <h4 class="content-subtitle">Custom values</h4>
        <div class="detail-table-head">
          <!-- <span class="x-small">Type</span> -->
          <span class="large">Description</span>
          <span class="big">Input (by operator)</span>
        </div>
        <div class="detail-table-body" v-if="details.stepValues.length > 0">
          <div class="body-row"
            v-for="(val, index) in details.stepValues" 
            :key="index"
          >
            <span class="large">{{ val.name }}</span>
            <!-- <span v-if="!details.stepCompletion && val && val.value != ''" class="big">{{ val.value == "true" ? "OK" : val.value == "false" ? "NOK" : val.value}}</span> -->
            <!-- <span v-else-if="!details.stepCompletion"  class="big no-completion"> - step not completed -</span> -->
            <!-- <span v-else class="big"> - </span> -->
            <span v-if="!details.stepCompletion"  class="big no-completion"> - step not completed -</span>
            <span v-else-if="(val.value =='true'||val.value=='false') && val && val.value != ''" class="big">{{ val.value == "true" ? "OK" : val.value == "false" ? "NOK" : val.value}}</span>
            <span v-else-if="val" class="big">{{ val.value }}</span>
            <!-- <span v-else class="big"> - </span> -->
            <span v-else class="big">{{ val.value }}</span>
          </div>
        </div>
        <span v-else class="no-data">No custom values for this step</span>
      </table>
    </div>
  </div>
</template>

<script>
import BaseIcon from "@/components/base/Icon";
import BaseButton from "@/components/base/Button";

export default {
  components: {
    BaseIcon,
  },
  props: {
    data: Object,
  },
  mounted() {
    this.details = this.data
  },
  data() {
    return {
      details: null,
      isLoading: false,
      isQROpen: false,
      qrString: [],
      openedQR: '',
    };
  },
  methods: {
    openQR(id) {
      this.qrString = []
      if (this.details.stepDetails.QRParameter !== null) {
        let params = this.details.stepDetails.QRParameters
        if (params !== undefined) {
          params.forEach((param, index) => {
            this.qrString[index] = '{"result": "' + this.details.stepDetails.stepID + '", "name": "' + this.details.stepDetails.name + '", "type": "workstation", "company": "SurgiTec", "QRParam": "' + param.name + '"}'
          });
        } else {
          var that = this
          that.$swal(
            'Oops that went wrong?',
            `Please contact the admin with the following info: QR-Code params undefined`,
            'error'
          );
        }
      } else {
        this.qrString[0] = '{"result": "' + this.details.stepDetails.stepID + '", "name": "' + this.details.stepDetails.name + '", "type": "workstation", "company": "SurgiTec"}'
      }

      this.isQROpen = true
      this.openedQR = id
    },
    closeQR() {
      this.isQROpen = false
      this.openedQR = ''
    },
  },
  watch:{
    data: {
      handler: function() {
        this.details = this.data
      },
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/pages/dhrdetail.scss";
@import "@/style/components/QRCodes.scss";


.no-completion {
  color: #6A6A6A;
  font-style: italic;
  font-weight: 500;
  font-size: 12px;
}

.no-data {
  color: #6A6A6A;
  font-weight: 400;
  font-style: italic;
  padding-top: 16px;
}



.qr-button {
  position: absolute;
  left: 180px;
  cursor: pointer;
    z-index: 9999;
}

  .fullscreen{
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999;
    background-color: rgba($color: #000000, $alpha: 0.16);

    display: flex;
    justify-content: center;
    align-items: center;

    .imageview {
      min-height: 320px;
      min-width: 320px;
      height: 40%;
      width: 20%;
      padding: 24px 40px;
      background-color: white;
      border-radius: 8px;

      display: flex;
      justify-content: center;
      align-items: center;
      
      .btn-close {
        position: absolute;
        top: 24px;
        right: 24px;
        width: 32px;
        height: 32px;
  
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
  
        background-color: none;
        border: none;
  
        .icon {
          font-size: 18px;
          color: #D0D0D0;
        }
  
        &:hover {
          background-color: none;
          cursor: pointer;
          .icon {
            font-size: 18px;
            color: #6A6A6A;
          }
        }
      }
    }
  }
</style>
